<div class="row">
  <div class="col-12">
    <h3>Provider Fax Status Review Required</h3>

    <form [formGroup]="formGroup" novalidate>
      <div class="container-fluid p-2 border bg-light mb-2">
        <div class="row">
          <div class="col-2 pe-1">
            <div class="mb-3" formGroupName="filters">
              <label>
                Review Status:
              </label>
              <ng-select
                class="w-100"
                name="reviewStatus"
                bindValue="value"
                bindLabel="display"
                [multiple]="true"
                [items]="filterOptions"
                [clearable]="true"
                [searchable]="false"
                placeholder="Filter by Status"
                formControlName="reviewStatus" />
            </div>
          </div>

          <div class="col-2 pe-1">
            <div class="mb-3">
              <label>
                Sort By:
              </label>
              <ng-select
                class="w-100"
                name="sortBy"
                bindValue="value"
                bindLabel="display"
                [multiple]="false"
                [items]="sortByOptions"
                [clearable]="false"
                [searchable]="false"
                formControlName="sort" />
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

@if (!loading) {
  <div class="mt-2">
    <app-pagination-header
      [paging]="paging"
      [label]="'reviews'"
      (pageSizeChange)="onPageSizeChange($event)"
      [includeResetFiltersButton]="true"
      (resetFiltersClick)="onResetFiltersClick()" />
    @if (statusReviews.length > 0) {
      <div class="mt-2">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>Provider Information</th>
              <th>Office Information</th>
              <th>Current Provider Fax Status</th>
              <th>Association Note</th>
              <th>Fax Association Review</th>
              <th>Review Created On</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            @for (statusReview of statusReviews; track statusReview) {
              <tr>
                <td>
                  <div>
                    <a href="/capture-admin/providers/{{statusReview.provider.npi}}" target="_blank">
                      @if (statusReview.provider.credentials) {
                        <span>
                          {{ statusReview.provider.first }} {{ statusReview.provider.last }}, {{ statusReview.provider.credentials }}
                        </span>
                      }
                      @if (!statusReview.provider.credentials) {
                        <span>
                          {{ statusReview.provider.first }} {{ statusReview.provider.last }}
                        </span>
                      }
                    </a>
                  </div>
                  <div>
                    NPI: {{ statusReview.provider.npi }}
                  </div>
                  <div>
                    NPI Review Status:
                    @if (keyedProviderStatusOptions[statusReview.provider.status]) {
                      {{ keyedProviderStatusOptions[statusReview.provider.status].display | blankValueDash }}
                    } @else {
                      {{ statusReview.provider.status | blankValueDash }}
                    }
                  </div>
                </td>
                <td>
                  <app-office [office]="statusReview.office" />
                  <div>
                    Office Status: {{ keyedOfficeStatusOptions[statusReview.office.status]?.display | blankValueDash }}
                  </div>
                </td>
                <td>
                  <app-provider-office-fax-status
                    [providerOffice]="statusReview"
                    (providerOfficeChanged)="onProviderOfficeChanged($event)"
                    [clearReviewStatus]="true" />
                </td>
                <td>
                  <app-notes-for-model
                    [model]="statusReview"
                    [modelType]="'ProviderOffice'"
                    [allowAdd]="true"
                    [noNotesMessage]="null" />
                </td>
                <td>
                  {{ keyedProviderOfficeStatusOptions[statusReview.reviewStatus]?.display | blankValueDash }}
                  @if (statusReview.reviewInboundCommunication?.type === 'InboundFax') {
                    <div>
                      <a href="/capture-admin/communications/inbound-faxes/{{ statusReview.reviewInboundCommunication.id }}"
                        target="_blank">
                        Inbound Fax: {{ statusReview.reviewInboundCommunication.id }}
                      </a>
                    </div>
                  }
                  @if (statusReview.reviewInboundCommunication?.type === 'InboundCall') {
                    <div>
                      <a href="/capture-admin/communications/inbound-calls/{{ statusReview.reviewInboundCommunication.id }}"
                        target="_blank">
                        Inbound Call: {{ statusReview.reviewInboundCommunication.id }}
                      </a>
                    </div>
                  }
                </td>
                <td>{{ statusReview.reviewStatusAddedAt | date: 'M/d/yyyy' | blankValueDash }}</td>
                <td class="row-actions">
                  <a href="#"
                    class="clear-review"
                    (click)="onClearReviewClick($event, statusReview)">
                    Clear Review
                  </a>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <div class="mt-2">
          <app-pagination [paging]="paging" (pageChange)="onPageChange()" />
        </div>
      </div>
    } @else {
      <p class="ms-1">No provider offices requiring review.</p>
    }
  </div>
} @else {
  @if (loading) {
    <div class="ms-1"><mat-spinner diameter="30" /></div>
  }
}


